import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs, deleteBlog } from "store/blogSlice";
import { useHistory } from "react-router-dom";

export default function BlogTable({ color }) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { items: blogs, loading, error } = useSelector(
    (state) => state.blogs
  );

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  const handleCreate = () => {
    history.push("/admin/blog/create");
  };

  const handleEdit = (id) => {
    history.push(`/admin/blog/edit/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      dispatch(deleteBlog(id));
    }
  };

  return (
    <div
      className={
        "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
        (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
      }
    >
      {/* Header */}
      <div className="rounded-t mb-0 px-4 py-3 border-0 flex justify-between">
        <h3
          className={
            "font-semibold text-lg " +
            (color === "light"
              ? "text-blueGray-700"
              : "text-white")
          }
        >
          Blog List
        </h3>

        <button
          onClick={handleCreate}
          className="bg-lightBlue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-600"
        >
          + Create Blog
        </button>
      </div>

      {/* Table */}
      <div className="block w-full overflow-x-auto">
        <table className="items-center w-full bg-transparent border-collapse">
          <thead>
            <tr>
              {["Image", "Title","Slug", "Published", "Created At", "Actions"].map(
                (h, i) => (
                  <th
                    key={i}
                    className={`px-6 py-3 text-xs uppercase font-semibold text-left ${
                      color === "light"
                        ? "bg-blueGray-50 text-blueGray-500"
                        : "bg-lightBlue-800 text-lightBlue-300"
                    }`}
                  >
                    {h}
                  </th>
                )
              )}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center p-4">
                  Loading...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="5" className="text-center p-4 text-red-500">
                  {error}
                </td>
              </tr>
            ) : blogs.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center p-4">
                  No blogs found.
                </td>
              </tr>
            ) : (
              blogs.map((blog) => (
                <tr key={blog.id}>
                  <td className="px-6 py-4">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="h-12 w-16 object-cover rounded"
                    />
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {blog.title}
                  </td>
                  <td className="px-6 py-4 text-sm text-blueGray-600">
                    {blog.slug}
                  </td>

                  <td className="px-6 py-4 text-sm">
                    {blog.is_published ? "Yes" : "No"}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    {new Date(blog.created_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 text-sm">
                    <button
                      onClick={() => handleEdit(blog.id)}
                      className="bg-yellow-500 text-white px-3 py-1 rounded mr-2 text-xs"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(blog.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded text-xs"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

BlogTable.defaultProps = {
  color: "light",
};

BlogTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
